import { render, staticRenderFns } from "./SafeAreaInsetBottom.vue?vue&type=template&id=a2318dea&scoped=true&"
import script from "./SafeAreaInsetBottom.vue?vue&type=script&lang=js&"
export * from "./SafeAreaInsetBottom.vue?vue&type=script&lang=js&"
import style0 from "./SafeAreaInsetBottom.vue?vue&type=style&index=0&id=a2318dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2318dea",
  null
  
)

export default component.exports